const API_URL = process.env.REACT_APP_API_URL;
const AUTH_URL = `${API_URL}/api/auth`;

export const register = async userData => {
    try {
        const response = await fetch(`${AUTH_URL}/register`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(userData),
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || 'Registration failed');
        }

        return data;
    } catch (error) {
        throw error;
    }
};

export const verifyEmail = async token => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/verify`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token }),
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || 'Verification failed');
        }

        return data;
    } catch (error) {
        throw error;
    }
};

export const login = async userData => {
    try {
        const response = await fetch(`${AUTH_URL}/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(userData),
        });

        const data = await response.json();

        if (!response.ok) {
            if (data.error === 'Invalid credentials') {
                throw new Error('Incorrect email or password');
            }
            throw new Error(data.error || 'Login failed');
        }

        return data;
    } catch (error) {
        throw error;
    }
};

export const logout = async () => {
    const response = await fetch(`${AUTH_URL}/logout`, {
        method: 'POST',
        credentials: 'include',
    });

    if (!response.ok) {
        throw new Error('Logout failed');
    }

    return response.json();
};

export const fetchAuthCheck = async () => {
    try {
        const response = await fetch(`${AUTH_URL}/check`, {
            credentials: 'include',
        });
        return response;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to fetch auth check');
    }
};

// WAITLIST_PHASE
export const joinWaitlist = async (email, referralCode, sourceInfo) => {
    const response = await fetch(`${AUTH_URL}/waitlist`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, referralCode, sourceInfo }),
    });

    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.error || 'Failed to join waitlist');
    }

    return data;
};

export const googleAuth = async token => {
    try {
        const response = await fetch(`${AUTH_URL}/google`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token }),
            credentials: 'include',
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || 'Google authentication failed');
        }

        return data;
    } catch (error) {
        throw error;
    }
};

export const googleOneTapAuth = async credential => {
    try {
        const response = await fetch(`${AUTH_URL}/google/onetap`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token: credential }),
            credentials: 'include',
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || 'Google One Tap authentication failed');
        }

        return data;
    } catch (error) {
        throw error;
    }
};
